var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-ski",class:[
    _vm.padding,
    _vm.opaque ? 'btn-info-opacity' : null,
    _vm.computedTextVariant,
    _vm.nextToAnotherBox ? 'my-4' : null
  ],attrs:{"variant":_vm.variant,"href":_vm.to,"target":_vm.target}},[(!_vm.left)?_c('span',{staticClass:"mr-large"},[_vm._t("default")],2):_vm._e(),_vm._t("icon",[_c('arrow',{staticClass:"svg"})]),(_vm.left)?_c('span',{staticClass:"ml-3"},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }